import { stripSeoRelFromInternalAnchors } from './richtextInternalDofollow';

export function stripHtmlToText(html) {
  return String(html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function looksLikeHtml(value) {
  const s = String(value || '').trim();
  return s.length > 0 && /<[a-z][\s\S]*>/i.test(s);
}

export function prepareCollectionHtml(html, siteOrigin) {
  const raw = String(html || '').trim();
  if (!raw) return '';
  if (!looksLikeHtml(raw)) return raw;
  return stripSeoRelFromInternalAnchors(raw, siteOrigin) || '';
}

export function collectionPlainText(html) {
  return stripHtmlToText(html);
}
